import { h, Component } from 'preact';
import {Form, FormEntry, Button, I18n, Col, Container, Row} from 'components/elements'
import {connect} from 'react-redux'
import style from './index.less'
import {AccountActions, PageActions, SessionActions} from 'actions'
import store from 'reducers'

@Form
@connect((state)=> state)
export default class ProfileSelect extends Component {
    constructor(props, context){
        super(props, context)
        this.state = {
        }
        this.handleSelect = this.handleSelect.bind(this)
    }

    get profiles(){
        return _.get(this, 'props.session.account.users', [])
    }

    handleSelect(a){
        console.log(a)
    }
    render(){
        const {InputDark, Form} = this.props
        return (
            <Form class={style.login} onSubmit={this.handleLogin}>
                <Row class={this.props.class}>
                    <Col span={{sm:'hidden', md:5}}></Col>
                    <Col span={{sm:24, md:14}}>
                        <Container>
                            <Row>
                                <Col span={{md:1, sm: 'hidden'}}></Col>
                                <Col span={{sm: 24, md:22}} class={style.noPadding}> 
                                    <h2>
                                        <I18n>selectYourProfile</I18n>
                                    </h2>
                                    <br />
                                    {this.profiles.map((profile)=>{
                                        <a onClick={this.handleSelect.bind(null, profile)}>
                                            {profile.proposedEmail}
                                            <br />
                                            {profile.proposedMobilePhone}
                                            <br />
                                            {profile.proposedFirstName} {profile.proposedLastName}
                                        </a>
                                    })}
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./components/partials/ProfileSelect/index.js